import type { FaireProductEntity } from "../../entity_types/product";

export const p_kt5afg4bd3: FaireProductEntity = {
  token: "p_kt5afg4bd3",
  type: "product",
  name: "Next Chapter Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1ba88e5fb452bbf7e77151ae543b278067c8807de3f0251e54f15953c7e680bb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d52d723c804ac4fa1c14f18790c5101348eae015587365c4661acf7becc7bb4.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:50.385Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
